import { QueryKeys } from "../queryKeys.ts";
import { useStoreActions } from "../../../contexts.ts";
import { useQueryState } from "../useQueryState.tsx";
import { useCallback } from 'react';
export const useRelationship = function useRelationship(relationshipId) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    resolvePaymentMethod = true
  } = options;
  const {
    api
  } = useStoreActions();
  const {
    data: relationship,
    isLoading,
    refresh,
    isBackgroundLoading,
    optimisticUpdate,
    error
  } = useQueryState({
    queryKey: [QueryKeys.Relationship, relationshipId, resolvePaymentMethod],
    queryFn: () => api.relationship.get(relationshipId, {
      resolvePaymentMethod
    }),
    refreshOnMount: options.refreshOnMount,
    enabled: !!relationshipId
  });
  const refreshRelationship = useCallback(async function () {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      silent: false
    };
    const {
      data
    } = await refresh(options);
    return data;
  }, [refresh]);
  return {
    relationship,
    optimisticUpdate,
    refresh: refreshRelationship,
    isLoading,
    isBackgroundLoading,
    error
  };
};
export const useNonNullableRelationship = function useNonNullableRelationship() {
  const data = useRelationship(...arguments);
  if (!data.relationship) {
    throw new Error('Relationship not found');
  }
  return data;
};